export var ArticleFeedbackType;
(function (ArticleFeedbackType) {
    ArticleFeedbackType["HELPFUL"] = "helpful";
    ArticleFeedbackType["NOT_HELPFUL"] = "not-helpful";
    ArticleFeedbackType["VOTE"] = "vote";
    ArticleFeedbackType["REPORT"] = "report";
})(ArticleFeedbackType || (ArticleFeedbackType = {}));
//# sourceMappingURL=article-feedback-type.enum.js.map